import { MapPinIcon, WifiIcon } from '@heroicons/react/24/outline'
import { useComponentTranslation } from '@tebuto/functions/translation.components'
import ExtraSmallText from '@tebuto/typography/ExtraSmallText'
import { EventLocation } from '../types'

export default function LocationIndicator({ location }: { location: EventLocation }) {
    const { t } = useComponentTranslation()

    if (location === 'not-fixed') {
        return (
            <div className="flex items-center gap-2">
                <div className="flex items-center gap-1">
                    <MapPinIcon className="size-4 widget-text-primary-color-600 opacity-60" />
                    <ExtraSmallText className="text-xxs widget-text-primary-color-700">{t('onsite')}</ExtraSmallText>
                </div>
                <div className="flex items-center gap-1">
                    <WifiIcon className="size-4 widget-text-primary-color-600 opacity-60" />
                    <ExtraSmallText className="text-xxs widget-text-primary-color-700">{t('online')}</ExtraSmallText>
                </div>
            </div>
        )
    }

    if (location === 'onsite') {
        return (
            <div className="flex items-center gap-1">
                <MapPinIcon className="size-4 widget-text-primary-color-600 opacity-60" />
                <ExtraSmallText className="text-xxs widget-text-primary-color-700">{t('onsite')}</ExtraSmallText>
            </div>
        )
    }

    if (location === 'virtual') {
        return (
            <div className="flex items-center gap-1">
                <WifiIcon className="size-4 widget-text-primary-color-600 opacity-60" />
                <ExtraSmallText className="text-xxs widget-text-primary-color-700">{t('online')}</ExtraSmallText>
            </div>
        )
    }
}
